import * as User from '../../user'

export const userFrom = (payload: any) => {
  const user: User.User = {
    account_name : payload.account_name,
    email_address : payload.email_address,
    first_name : payload.first_name,
    last_name : payload.last_name,
    roles : payload.roles,
  }
  return user
}



// WEBPACK FOOTER //
// ./src/components/menu/user-menu/utils.ts